import { type StatsigLayerName, getStatsigClientInstance } from '@coursera-web/statsig';

import { DEFAULT_LICENSE_COUNT } from 'bundles/wes-common/constants/billing';

/**
 * Statsig experiment `wes-teams-default-licenses` on this layer (ENTPYMTS-2114).
 * Control: `default_value` = 2; Test: `default_value` = 5.
 */
export const WES_TEAMS_DEFAULT_LICENSES_LAYER: StatsigLayerName = 'wes-teams-default-licenses-layer';

/** Layer parameter that holds the default checkout license count. */
export const WES_TEAMS_DEFAULT_LICENSES_PARAM = 'default_value';

/**
 * Default `learnerCount` when absent from the URL (e.g. `/purchase/plan` redirect).
 * Reads `wes-teams-default-licenses-layer` via `.get()` so exposure is logged at this call site.
 * Uses `getStatsigClientInstance()` because this helper is a non-React utility (route `onEnter`, etc.).
 * Falls back to {@link DEFAULT_LICENSE_COUNT} if Statsig is unavailable (e.g. pre-init / non-Statsig consumers).
 */
export function getDefaultCheckoutLearnerCount(): number {
  try {
    const layer = getStatsigClientInstance().getLayer(WES_TEAMS_DEFAULT_LICENSES_LAYER);
    const defaultLicenseCount = layer.get(WES_TEAMS_DEFAULT_LICENSES_PARAM, DEFAULT_LICENSE_COUNT);

    return typeof defaultLicenseCount === 'number' ? defaultLicenseCount : DEFAULT_LICENSE_COUNT;
  } catch {
    return DEFAULT_LICENSE_COUNT;
  }
}
